/* THIS FILE IS AUTO-GENERATED BY LABEL SERVICES */
const en_US = {
  BACK_TO_PAGES: 'Back To Pages',
  NO_PREFERENCES_FOUND: 'No Preferences Found',
  CONFIRMATION: 'Confirmation',
  EXPORT: 'Export',
  ALL_CONDITIONS: 'All Conditions',
  CLOSE: 'Close',
  CERTIFIED: 'Certified',
  YEAR: 'Year',
  PAGE_PATH_INVALID: 'Invalid page path for your new page. Please adjust your url. ',
  CONTENT_TYPE: 'Content Type',
  SITEMAP_END_DATE: 'Remove from sitemap on',
  NONE: 'None',
  PATH_ERROR_MUST_END_IN_HTM: 'Page path must end in .htm. ',
  PAGE_SELECTED: '{count} Page Selected',
  SITECONTENT_NO_HISTORY: 'No History',
  FILTER_TYPE_CUSTOM_TOOLTIP: 'Pages created specifically for this dealership. These are unique to your site and fully editable. ',
  SEARCH: 'Search',
  PAGE_ALIAS: 'Page Alias',
  SELECT_A_CONDITION: 'Select a Condition',
  SITEMAP_MANAGE_PAGES: 'Manage Pages',
  SITEMAP_PAGES: 'Pages',
  PAGE_ID: 'Page Id',
  DELETE_PAGE_CONFIRM: 'Are you sure you want to remove this page?: ',
  FILTERED_PAGES_COUNT: '{filtered} of {total} pages',
  NO_INDEX_TOOLTIP: 'Prevents search engines from indexing this page. Deselect to allow indexing again. ',
  SELECT_PAGE_ID: 'Select PageId',
  ARE_YOU_SURE_YOU_WANT_TO_RESTORE_THIS_REVISION_NOTE: "Note: These changes will not be saved immediately. Click 'Save' to apply the changes to your live site. ",
  BATCH_LIMIT_CONFIRM: 'Go Back And Update Selections',
  CONDITION: 'Condition',
  REMOVE_PAGES: 'Remove Pages',
  NO_ITEMS_MATCH: 'No item matches',
  VIEW_LINK: 'View Link',
  PICK_A_GRADIENT: 'Pick a Gradient',
  FILTER_TYPE_CUSTOM: 'Custom',
  SITEMAP_END_DATE_INVALID: 'End date must be after the start date. ',
  DISCARD_CHANGES: 'Discard Changes',
  SELECT_MAKE_TO_FILTER_BY_MODELS: 'Select a make to filter by models',
  DRAFT_OF_PAGE_EXISTS_ALREADY: 'Draft of Page Exists Already',
  ERROR_LOADING_SITEMAP: 'Error loading Sitemap: {message} ',
  PICK_A_COLOR: 'Pick a Color',
  BATCH_UPDATE_LIMIT_MSG_3: 'Please reduce your selection to {batchUpdateLimit} pages or fewer, then try again. ',
  DELETE: 'Delete',
  PAGE_PATH: 'Page Path',
  GO_TO_DRAFT: 'Go To Draft',
  NO_INDEX: 'No Index',
  NO_FOLLOW: 'No Follow',
  SAVE: 'Save',
  CLEAR_FILTERS: 'Clear Filters',
  SHOW_IN_HTML_SITEMAP: 'Show in HTML Sitemap',
  YES_RESTORE_THIS_REVISION: 'Yes',
  SITECONTENT_HISTORY: 'Content History',
  MODEL: 'Model',
  DELETE_PAGES_WARNING: 'Deleting these pages may result in 404 errors if any of them are currently linked in your site navigation. To prevent invalid links, remove the associated items from your navigation before proceeding. ',
  LINK_TO_DVS_WEB_COMPARISON: 'Link to dvs-web comparison with current revision',
  INHERITED_DISTRIBUTED_PAGE_TOOLTIP: 'This page is {src} and originates from a parent site',
  ARE_YOU_SURE_YOU_WANT_TO_RESTORE_THIS_REVISION: 'Are you sure you want to load this revision? ',
  CANCEL: 'Cancel',
  NO_RESTORE_THIS_REVISION: 'No',
  STAY: 'Stay',
  NEW: 'New',
  NO_SITEMAP_DATA: 'No Sitemap Data Available',
  PAGE_ID_MISSING_ERROR: 'This page has no corresponding page ID and will 404',
  ERROR_MESSAGE_PAGE_DETAIL: 'Failed to load page details. Please try again. ',
  PAGES_SELECTED: '{count} Pages Selected',
  FILTER_TYPE_SITE_DEFAULT_TOOLTIP: 'Pages that come standard with your website template. These are pre-configured and included in every site setup. ',
  SITEMAP_START_DATE: 'Add to sitemap on',
  FILTER_TYPE_PROGRAM_TOOLTIP: 'Distributed content managed by an OEM or partner program. Edits may be limited or overwritten by program updates. ',
  BODY_STYLE_LOCALIZATION_WARNING: 'Body styles are localized and may return no results for multilingual sites. ',
  USED: 'Pre-Owned',
  DELETE_PAGE_WARNING: 'Deleting this page will result in a 404 error if the page is currently linked in your site navigation. To avoid invalid links, delete the associated item from your navigation. ',
  DELETE_PAGES_CONFIRM: 'Are you sure you want to delete the following pages?: ',
  DONE: 'Done',
  SHOW_IN_HTML_SITEMAP_TOOLTIP: "Includes this page in your site's HTML sitemap, helping visitors and search engines discover it more easily. Deselect to exclude it. ",
  FILTER_TYPE_PROGRAM: 'Program',
  NO_FOLLOW_TOOLTIP: 'Prevents search engines from following links on this page. Deselect to allow search engines to follow links normally. ',
  BATCH_UPDATE_LIMIT_MSG_2: 'To help prevent accidental data loss and manage risk, bulk updates are limited to {batchUpdateLimit} pages at a time. ',
  BATCH_UPDATE_LIMIT_MSG_1: "You've selected more than {batchUpdateLimit} pages. ",
  BATCH_DELETE_LIMIT_MSG_2: 'To help prevent accidental data loss and manage risk, bulk deletions are limited to {batchDeleteLimit} pages at a time. ',
  BATCH_DELETE_LIMIT_MSG_1: "You've selected more than {batchDeleteLimit} pages. ",
  BATCH_DELETE_LIMIT_MSG_3: 'Please reduce your selection to {batchDeleteLimit} pages or fewer, then try again. ',
  VIEW_MORE: 'View More',
  NO_MATCHING_RESULTS: 'No Matching Results',
  BATCH_UPDATE_LIMIT_TITLE: 'Bulk Update Limit Reached',
  MAKE: 'Make',
  BODYSTYLE: 'Bodystyle',
  PAGE_ALIAS_INVALID: 'Invalid page alias for your new page. This alias already exists. ',
  BATCH_EDIT_PAGE_DETAILS: 'Batch Edit Page Details',
  CLEAR_SEARCH_AND_FILTERS: 'Clear Search & Filters',
  OK: 'Ok',
  SHOW_IN_XML_SITEMAP_TOOLTIP: "Includes this page in your site's XML sitemap, helping search engines discover and index it. Deselect to exclude it. ",
  PATH_ERROR_BEGIN_WITH: "Path must begin with '/' or 'http:' ",
  OR: 'or',
  PATH_ERROR_MUST_NOT_CONTAIN_PLUS: 'The path must not contain "+". ',
  UNSAVED_CHANGES: 'Unsaved Changes',
  SHOW_IN_XML_SITEMAP: 'Show in XML Sitemap',
  SITEMAP_DELETE: 'Delete ({count}) ',
  BATCH_DELETE_LIMIT_TITLE: 'Bulk Deletion Limit Reached',
  PAGE_DETAILS: 'Page Details',
  UNSAVED_CHANGES_MESSAGE: 'You have unsaved changes. If you leave now, those changes will be lost. ',
  DRAFT_OF_PAGE_EXISTS_ALREADY_DESCRIPTION: 'You have changes in an unpublished draft of this page. Please publish or remove the draft page before continuing. ',
  SITEMAP_START_DATE_REQUIRED: 'This field is required',
  FILTER_TYPE_SITE_DEFAULT: 'Site Default',
  REMOVE_PAGE: 'Remove Page'
}
export default en_US;